export default __webpack_public_path__ + "static/model360-paris-a7aba51d580988eff9f6050a7bf647bd.png";